import { createFileRoute } from '@tanstack/react-router';

import { DispatchMapPage } from '../modules/ComponentsLibrary/Dispatch/DispatchMapPage';

export const Route = createFileRoute('/dispatch-map')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Dispatch Map - Live View' }],
    };
  },
});

function RouteComponent() {
  return <DispatchMapPage />;
}
